import React from "react";

type SpinnerSize = "xs" | "sm" | "md" | "lg";
type SpinnerVariant = "primary" | "default" | "gray-sand" | "brand";

const sizeMap: Record<SpinnerSize, string> = {
    xs: "w-4 h-4",
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
};

const variantMap: Record<SpinnerVariant, { track: string; head: string }> = {
    'primary': {
        track: "stroke-primary-30",
        head: "stroke-primary-100",
    },
    'brand': {
        track: "stroke-secondary-green-20",
        head: "stroke-brand",
    },
    'default': {
        track: "stroke-dark-10",
        head: "stroke-dark-40",
    },
    'gray-sand': {
        track: "stroke-white/30",
        head: "stroke-white",
    },
};

interface SpinnerProps {
    size?: SpinnerSize;
    variant?: SpinnerVariant;
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
    size = "md",
    variant = "default",
    className = "",
}) => {
    const { track, head } = variantMap[variant];
    return (
        <svg
            className={`animate-spin ${sizeMap[size]} ${className}`}
            viewBox="0 0 24 24"
            fill="none"
            role="status"
            aria-label="Loading"
        >
            <circle
                className={track}
                cx="12"
                cy="12"
                r="10"
                strokeWidth="4"
                fill="none"
            />
            <path
                className={head}
                strokeWidth="4"
                strokeLinecap="round"
                fill="none"
                d="M12 2
                A10 10 0 1 1 6.33 20.09"
            />
        </svg>
    );
};

export default Spinner;
